import { useEffect, useState, useMemo } from 'react';
import { useDebouncedState } from 'tradera/hooks/use-debounced-state';
import { getAliasSuggestions } from '../../api';
import { Button } from 'tradera/components/atoms/button/button';
import { logError, handleError } from 'tradera/utils/api';

type Props = {
    alias: string | null;
    email: string | null;
    firstName: string | null;
    lastName: string | null;
    onSelect: (alias: string) => void;
};

export const AliasSuggestions: React.FC<Props> = ({
    alias,
    email,
    firstName,
    lastName,
    onSelect
}) => {
    const [suggestions, setSuggestions] = useState<string[]>([]);

    const requestData = useMemo(
        () => ({ alias, email, firstName, lastName }),
        [alias, email, firstName, lastName]
    );
    const debouncedRequestData = useDebouncedState(requestData, 100);

    useEffect(() => {
        getAliasSuggestions(debouncedRequestData)
            .then((suggestions) => {
                setSuggestions(suggestions);
                return suggestions;
            })

            .catch(handleError())
            .catch(logError);
    }, [debouncedRequestData]);

    if (suggestions.length === 0) {
        return null;
    }
    return (
        <div className="mx-n3 px-3 py-1 mt-n2 mb-3 d-flex gap-x-1 overflow-x-auto hide-scrollbar">
            {suggestions.map((suggestion) => (
                <Button
                    theme="action"
                    variant="outline"
                    size="sm"
                    key={suggestion}
                    className="flex-shrink-0"
                    onClick={() => onSelect(suggestion)}>
                    {suggestion}
                </Button>
            ))}
        </div>
    );
};
